import { useMutation } from '@tanstack/vue-query';
import { login } from '../api/endpoints';

const useKeycloakLoginMutation = () => {
  return useMutation({
    async mutationFn(fields) {
      const params = new URLSearchParams();
      for (const key in fields) {
        params.append(key, fields[key]);
      }

      const { data } = await login(params);

      return data;
    },
  });
};

export default useKeycloakLoginMutation;
